import { useAtom } from 'jotai'
import { User } from 'lib/models'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom, resetAtom } = createAtom<User>({} as User, MMKVKey.User)

export const useUserAtom = () => useAtom(atom)
export const useResetUserAtom = () => useAtom(resetAtom)
